import React from "react";
import styles from "./Sports.css";

export default function OptInMessagePage() {
  return (
    <div className={styles.root}>
      <div className={styles.optin}>
        <img
          src={require("assets/img/referral-sports-confetti.png")}
          alt="Sign up for Sports!"
        />
        <p className={styles.text}>
          <h1>Thanks for signing up! One last step...</h1>
          <p>
            We just sent you an email with instructions to verify your account.
            If you didn’t receive anything, check your promotions tab or junk
            folder.
          </p>
          <p>
            <strong>Why it matters:</strong> We need to verify you’re you so
            your friend can get credit for sharing.
          </p>
        </p>
      </div>
    </div>
  );
}
